<app-top-banner />
<div class="container" *ngIf="!loading" [ngClass]="{'shorter': scheduleStatus === 'init'}">

  <!-- Schedule Status - Started Schedule -->
  <agenda-customer-ui-status *ngIf="scheduleStatus === 'init'" />

  <!-- Schedule Status - Opened Schedule - Not started-->
  <app-open-schedule *ngIf="scheduleStatus === 'opened'" [scheduleData]="openSchedules"
    (reloadAfterCancelSchedule)="reloadAfterCanceledSchedule()" />

  <!-- Schedule Status - No Status-->
  <div *ngIf="scheduleStatus === 'no-content'">
    <div class="container__schedule">
      <div class="container__schedule__icon-box">
        <img src="../../../../../assets/img/Icon_Scheduling-Review.svg" alt="Scheduling review icon">
      </div>
      <div class="container__schedule__text">
        <p id="schedule-text" class="container__schedule__text__title">{{ "no-status.title" | translate }}</p>
        <span id="schedule-description" class="container__schedule__text__description">{{ "schedule.scheduling-presentation" | translate }}</span>
      </div>
      <div class="dashboard__card__button-box" id="standard-button">
            <lib-button 
              id="btn-schedule" 
              type="primary" 
              (click)="redirectTo('osb')">
              <img src="./assets/lib/icons/Icon_Calendar.svg" alt="Calendar icon"> {{ 'dashboard.scheduling' | translate }}
            </lib-button>
        </div>
    </div>

    <div class="container__schedule">
      <div class="container__schedule__icon-box">
        <img src="../../../../../assets/img/Icon_Car_Info.svg" alt="Car info icon">
      </div>
      <p class="container__schedule__text__title">{{ "schedule.tracking" | translate }}</p>
      <span class="container__schedule__text__description">{{ "schedule.tracking-info" | translate }}</span>

      <div class="container__schedule__status-tracker">
        <div class="container__schedule__status-tracker__tracker">
          <fds-compact-vertical-tracker [simple]="true" [firstItem]="true" [inProgress]="true">
           <span class="content">{{ "dashboard.vehicle-dealer" | translate }}</span>
          </fds-compact-vertical-tracker>
          <fds-compact-vertical-tracker [simple]="true" [inProgress]="true">
            <span class="content">{{ "dashboard.checklist-vehicle" | translate }}</span>
          </fds-compact-vertical-tracker>
          <fds-compact-vertical-tracker [simple]="true" [inProgress]="true">
            <span class="content">{{ "dashboard.vehicle-delivery" | translate }}</span>
          </fds-compact-vertical-tracker>
        </div>
      </div>
    </div>

    <div class="container__schedule" *ngIf="!isFordPass && !isPerks" >
      <div class="container__schedule__icon-box">
        <img src="../../../../../assets/img/Icon_Schedule-Service.svg" alt="Schedule service icon">
      </div>
      <p class="container__schedule__text__title">{{ "schedule.schedule-question" | translate }}</p>
      <span class="container__schedule__text__description">{{ "schedule.ask-schedule" | translate }}</span>

      <div class="fds-button-box" (click)="goToSchedule()">
        <button class="fds-button">{{ "button.schedule" | translate }} <img class="fds-button-icon"
            src="../../../../../assets/img/Icon_Arrow.svg" alt="go to schedule page"></button>
      </div>
    </div>
  </div>
</div>

<div *ngIf="loading" class="loading">
  <circular-indicator style="align-self: center;" [percentage]="0" [size]="100">
  </circular-indicator>
</div>
